/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$0 as $0,
  rec_B2 as B2,
  rec_D4 as D4,
  rec_FiltrosOrganigrama as FiltrosOrganigrama,
  rec_G4 as G4,
  rec_H2 as H2,
  rec_H4 as H4,
  rec_JSXRuntime as JSXRuntime,
  rec_Jr as Jr,
  rec_K4 as K4,
  rec_Mr as Mr,
  rec_Ni as Ni,
  rec_P4 as P4,
  rec_R2 as R2,
  rec_React as React,
  rec_Ti as Ti,
  rec_U4 as U4,
  rec_Ur as Ur,
  rec_V2 as V2,
  rec_W4 as W4,
  rec_bs as bs,
  rec_di as di,
  rec_gi as gi,
  rec_hi as hi,
  rec_ii as ii,
  rec_m0 as m0,
  rec_q2 as q2,
  rec_q4 as q4,
  rec_z2 as z2,
  rec_z4 as z4,
} from "../../runtime/index.jsx";
export function LienzoOrganigrama({
  arbol: e,
  onAbrir: t,
  enfocar: n,
  onDescargar: r,
  titulo: i = `Organigrama completo`,
}) {
  let { raices: a, porId: o } = e,
    [s, c] = (0, React.useState)(() => z2(a, 1)),
    l = (0, React.useMemo)(() => R2(a, s), [a, s]),
    [u, f] = (0, React.useState)(!1),
    [p, m] = (0, React.useState)(null),
    h = (0, React.useRef)(null),
    g = m0(h, {
      abajo: 32,
      minimo: 420,
    }),
    [_, v] = (0, React.useState)(null),
    [y, b] = (0, React.useState)(null),
    [x, S] = (0, React.useState)(null),
    [C, w] = (0, React.useState)(null),
    T = (0, React.useRef)(null),
    E = (0, React.useRef)(null),
    D = (0, React.useRef)(l);
  (0, React.useEffect)(() => {
    D.current = l;
  }, [l]);
  let [O, k] = (0, React.useState)(null);
  async function A(e) {
    if (O || !r) return;
    k(e);
    let t = (e) => +!e.fila.referencia + e.hijos.reduce((e, n) => e + t(n), 0),
      n = a.reduce((e, n) => e + t(n), 0);
    try {
      await r({
        tipo: e,
        puestos: n,
        generar: () => (e === `excel` ? j() : P4(E.current, l, i)),
      });
    } finally {
      k(null);
    }
  }
  async function j() {
    let e = s;
    c(new Set());
    let t = null;
    try {
      (await new Promise((e) => setTimeout(e, 700)),
        (t = await D4(E.current, D.current)));
    } catch {
    } finally {
      c(e);
    }
    await z4({
      raices: a,
      imagen: t,
      titulo: i,
      empresa: bs(),
    });
  }
  let [M, N] = (0, React.useState)(!1);
  function P() {
    (N(!0), document.documentElement.requestFullscreen?.().catch(() => {}));
  }
  function F() {
    (N(!1),
      document.fullscreenElement &&
        document.exitFullscreen?.().catch(() => {}));
  }
  (0, React.useEffect)(() => {
    if (!M) return;
    let e = () => {
        document.fullscreenElement || N(!1);
      },
      t = (e) => {
        e.key === `Escape` &&
          !document.fullscreenElement &&
          !document.querySelector(`[role=dialog]`) &&
          N(!1);
      };
    return (
      document.addEventListener(`fullscreenchange`, e),
      document.addEventListener(`keydown`, t),
      () => {
        (document.removeEventListener(`fullscreenchange`, e),
          document.removeEventListener(`keydown`, t));
      }
    );
  }, [M]);
  let I =
    y ??
    (_
      ? q4(_, l, a, o, s)
      : {
          escala: 1,
          x: H4,
          y: H4,
        });
  (0, React.useEffect)(() => {
    let e = h.current;
    if (!e) return;
    let t = () =>
      v({
        ancho: e.clientWidth || 1e3,
        alto: e.clientHeight || 600,
      });
    if ((t(), typeof ResizeObserver > `u`)) return;
    let n = new ResizeObserver(t);
    return (n.observe(e), () => n.disconnect());
  }, []);
  let [L, R] = (0, React.useState)(null);
  if (n && n !== L) {
    R(n);
    let e = new Set(s);
    for (let t of H2(o, n.id)) e.delete(t);
    (c(e),
      S(n.id),
      w({
        id: n.id,
      }),
      m(n.id));
  }
  if (C && _) {
    let e = l.nodos.find((e) => e.id === C.id);
    e &&
      (w(null),
      f(!0),
      C.equipo
        ? b(
            V2(l.nodos, K4(o, s, e.id), _, {
              minimo: U4,
            }),
          )
        : b({
            escala: 1,
            x: _.ancho / 2 - (e.x + $0.ancho / 2),
            y: _.alto / 3 - e.y,
          }));
  }
  function z(e) {
    let t = B2(s, o, e);
    for (let n of H2(o, e)) t.delete(n);
    (c(t),
      m(e),
      w({
        id: e,
        equipo: !0,
      }));
  }
  function ee(e, t, n, r = !1) {
    (f(r),
      b((r) => {
        let i = r ?? I,
          a = W4(i.escala * e),
          o = t ?? (_?.ancho ?? 0) / 2,
          s = n ?? (_?.alto ?? 0) / 2;
        return {
          escala: a,
          x: o - (o - i.x) * (a / i.escala),
          y: s - (s - i.y) * (a / i.escala),
        };
      }));
  }
  let te = (0, React.useRef)(ee);
  ((0, React.useEffect)(() => {
    te.current = ee;
  }),
    (0, React.useEffect)(() => {
      let e = h.current;
      if (!e) return;
      let t = (t) => {
        t.preventDefault();
        let n = e.getBoundingClientRect();
        te.current(
          Math.exp(-t.deltaY * 0.0015),
          t.clientX - n.left,
          t.clientY - n.top,
        );
      };
      return (
        e.addEventListener(`wheel`, t, {
          passive: !1,
        }),
        () => e.removeEventListener(`wheel`, t)
      );
    }, []));
  function B(e) {
    e.target.closest(`button`) ||
      ((T.current = {
        x: e.clientX,
        y: e.clientY,
        base: I,
      }),
      f(!1),
      e.currentTarget.setPointerCapture?.(e.pointerId));
  }
  function V(e) {
    let t = T.current;
    t &&
      b({
        ...t.base,
        x: t.base.x + e.clientX - t.x,
        y: t.base.y + e.clientY - t.y,
      });
  }
  function H() {
    T.current = null;
  }
  function ne(e) {
    if (e.target !== h.current) return;
    let t = {
      ArrowLeft: [80, 0],
      ArrowRight: [-80, 0],
      ArrowUp: [0, 80],
      ArrowDown: [0, -80],
    }[e.key];
    t
      ? (e.preventDefault(),
        f(!0),
        b({
          ...I,
          x: I.x + t[0],
          y: I.y + t[1],
        }))
      : e.key === `+` || e.key === `=`
        ? ee(1.2, void 0, void 0, !0)
        : e.key === `-`
          ? ee(1 / 1.2, void 0, void 0, !0)
          : e.key === `0` && re();
  }
  function re() {
    (f(!0), _ && b(G4(_, l)));
  }
  function ie(e) {
    (m(e),
      s.has(e)
        ? (c(B2(s, o, e)),
          w({
            id: e,
            equipo: !0,
          }))
        : (c(new Set(s).add(e)),
          w({
            id: e,
          })));
  }
  let U = p && o.has(p) ? [...H2(o, p)].reverse().concat(p) : [];
  return a.length ? (
    <div
      ref={h}
      role={`application`}
      aria-label={`Telaraña del organigrama`}
      aria-roledescription={`organigrama`}
      tabIndex={0}
      onPointerDown={B}
      onPointerMove={V}
      onPointerUp={H}
      onPointerCancel={H}
      onKeyDown={ne}
      style={{
        height: M ? `100dvh` : (g ?? `70vh`),
        backgroundColor: `var(--bg)`,
        backgroundImage: `radial-gradient(var(--border) 1px, transparent 1px), linear-gradient(var(--panel), var(--panel))`,
        backgroundSize: `22px 22px, auto`,
      }}
      className={`${M ? `fixed inset-0 z-[45] rounded-none border-0` : `relative rounded-2xl border`} cursor-grab touch-none overflow-hidden border-(--border) outline-none select-none focus-visible:ring-2 focus-visible:ring-(--accent-border) active:cursor-grabbing`}
      children={[
        <div
          ref={E}
          className={`absolute top-0 left-0 origin-top-left will-change-transform ${u ? `motion-safe:transition-transform motion-safe:duration-500 motion-safe:ease-out` : ``}`}
          style={{
            width: l.ancho,
            height: l.alto,
            transform: `translate(${I.x}px, ${I.y}px) scale(${I.escala})`,
          }}
          children={[
            <svg
              key={`${l.nodos.length}:${l.ancho}:${l.alto}`}
              width={l.ancho}
              height={l.alto}
              className={`animar-fundido pointer-events-none absolute top-0 left-0 overflow-visible`}
              aria-hidden={`true`}
              children={
                <path
                  d={l.lineas.join(``)}
                  fill={`none`}
                  style={{
                    stroke: `var(--text)`,
                    strokeOpacity: 0.35,
                    strokeWidth: 1.5,
                  }}
                />
              }
            />,
            l.nodos.map((e) => (
              <div
                key={e.id}
                className={`animar-fundido absolute motion-safe:transition-[left,top] motion-safe:duration-500 motion-safe:ease-out`}
                style={{
                  left: e.x,
                  top: e.y,
                  width: $0.ancho,
                  height: $0.alto,
                }}
                children={[
                  <FiltrosOrganigrama
                    fila={e.fila}
                    onAbrir={t}
                    resaltada={x === e.id || p === e.id}
                    mostrarFoto={I.escala >= 0.35}
                  />,
                  e.aCargo > 0 && (
                    <button
                      type={`button`}
                      onClick={() => ie(e.id)}
                      aria-label={
                        e.colapsado
                          ? `Abrir: ${e.debajo} personas debajo`
                          : `Cerrar lo que tiene debajo`
                      }
                      aria-expanded={!e.colapsado}
                      data-solo-pantalla={``}
                      title={
                        e.colapsado
                          ? `Ver su equipo (${e.debajo} personas debajo)`
                          : `Cerrar`
                      }
                      className={`absolute -bottom-3.5 left-1/2 z-10 inline-flex min-h-7 min-w-8 -translate-x-1/2 items-center justify-center rounded-full border px-2.5 text-xs font-semibold shadow-sm transition hover:scale-110 ${e.colapsado ? `border-(--accent) bg-(--accent) text-(--accent-fg)` : `border-(--border) bg-(--bg) text-(--text-h)`}`}
                      children={e.colapsado ? `+${e.debajo}` : `−`}
                    />
                  ),
                ]}
              />
            )),
          ]}
        />,
        U.length > 0 && (
          <nav
            aria-label={`Camino en el organigrama`}
            className={`animar-entrada absolute right-3 bottom-3 left-3 flex flex-wrap items-center gap-1 rounded-2xl border border-(--border) bg-(--bg) p-1.5 shadow-sm sm:right-auto sm:max-w-[70%]`}
            children={U.map((e, t) => {
              let n = o.get(e).fila,
                r = t === U.length - 1;
              return (
                <span
                  key={e}
                  className={`inline-flex min-w-0 items-center gap-1`}
                  children={[
                    t > 0 && (
                      <Mr
                        className={`h-3.5 w-3.5 shrink-0 text-(--text)`}
                        aria-hidden={`true`}
                      />
                    ),
                    <button
                      type={`button`}
                      onClick={() => z(e)}
                      aria-current={r ? `location` : void 0}
                      title={q2(n)}
                      className={`min-h-9 max-w-44 truncate rounded-xl px-2.5 text-xs ${r ? `bg-(--accent-bg) font-semibold text-(--accent-texto)` : `text-(--text-h) hover:bg-(--accent-bg)`}`}
                      children={q2(n)}
                    />,
                  ]}
                />
              );
            })}
          />
        ),
        <div
          className={`absolute top-3 right-3 flex flex-wrap items-center justify-end gap-1 rounded-2xl border border-(--border) bg-(--bg) p-1 shadow-sm`}
          children={[
            <button
              type={`button`}
              onClick={() => ee(1 / 1.25, void 0, void 0, !0)}
              aria-label={`Alejar`}
              className={`flex h-10 w-10 items-center justify-center rounded-xl hover:bg-(--accent-bg)`}
              children={(0, JSXRuntime.jsx)(gi, {
                className: `h-4 w-4`,
              })}
            />,
            <span
              className={`w-12 text-center text-xs tabular-nums text-(--text)`}
              children={[Math.round(I.escala * 100), `%`]}
            />,
            <button
              type={`button`}
              onClick={() => ee(1.25, void 0, void 0, !0)}
              aria-label={`Acercar`}
              className={`flex h-10 w-10 items-center justify-center rounded-xl hover:bg-(--accent-bg)`}
              children={<Ti className={`h-4 w-4`} />}
            />,
            <button
              type={`button`}
              onClick={re}
              aria-label={`Ver todo el organigrama`}
              title={`Ver todo`}
              className={`flex h-10 w-10 items-center justify-center rounded-xl hover:bg-(--accent-bg)`}
              children={<Ni className={`h-4 w-4`} />}
            />,
            <button
              type={`button`}
              onClick={M ? F : P}
              aria-label={
                M ? `Salir de pantalla completa` : `Pantalla completa`
              }
              aria-pressed={M}
              title={
                M ? `Salir de pantalla completa (Esc)` : `Pantalla completa`
              }
              className={`flex h-10 w-10 items-center justify-center rounded-xl hover:bg-(--accent-bg) ${M ? `bg-(--accent-bg) text-(--accent-texto)` : ``}`}
              children={
                M
                  ? (0, JSXRuntime.jsx)(hi, {
                      className: `h-4 w-4`,
                    })
                  : (0, JSXRuntime.jsx)(di, {
                      className: `h-4 w-4`,
                    })
              }
            />,
            r && (
              <JSXRuntime.Fragment
                children={[
                  <span
                    className={`mx-1 h-6 w-px bg-(--border)`}
                    aria-hidden={`true`}
                  />,
                  <button
                    type={`button`}
                    onClick={() => A(`excel`)}
                    disabled={!!O}
                    aria-label={`Descargar en Excel`}
                    title={`Informe de puestos en Excel: la tabla y el organigrama`}
                    className={`flex h-10 w-10 items-center justify-center rounded-xl hover:bg-(--accent-bg) disabled:opacity-60`}
                    children={
                      O === `excel` ? (
                        (0, JSXRuntime.jsx)(ii, {
                          className: `h-4 w-4 animate-spin`,
                        })
                      ) : (
                        <Ur className={`h-4 w-4`} />
                      )
                    }
                  />,
                  <button
                    type={`button`}
                    onClick={() => A(`imagen`)}
                    disabled={!!O}
                    aria-label={`Descargar el organigrama`}
                    title={`Descargar el organigrama como imagen, tal como está abierto`}
                    className={`flex h-10 w-10 items-center justify-center rounded-xl hover:bg-(--accent-bg) disabled:opacity-60`}
                    children={
                      O === `imagen` ? (
                        (0, JSXRuntime.jsx)(ii, {
                          className: `h-4 w-4 animate-spin`,
                        })
                      ) : (
                        <Jr className={`h-4 w-4`} />
                      )
                    }
                  />,
                ]}
              />
            ),
            <span
              className={`mx-1 h-6 w-px bg-(--border)`}
              aria-hidden={`true`}
            />,
            <button
              type={`button`}
              onClick={() => {
                (c(new Set()), f(!0), b(null), m(null));
              }}
              className={`h-10 rounded-xl px-3 text-xs text-(--text-h) hover:bg-(--accent-bg)`}
              children={`Abrir todo`}
            />,
            <button
              type={`button`}
              onClick={() => {
                (c(z2(a, 1)), f(!0), b(null), m(null));
              }}
              className={`h-10 rounded-xl px-3 text-xs text-(--text-h) hover:bg-(--accent-bg)`}
              children={`Cerrar`}
            />,
          ]}
        />,
      ]}
    />
  ) : (
    <p
      className={`rounded-2xl border border-(--border) p-4 text-sm text-(--text)`}
      children={`No hay puestos para mostrar con este filtro.`}
    />
  );
}
